import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../../CommonElements/Breadcrumbs/Breadcrumbs";
import CreateCTAForm from "./CreateCTAForm";
import { useLocation } from "react-router-dom";
const CreateCTAContainer = () => {
  const location = useLocation();
  const currentPathname = location.pathname;
  return (
    <>
      <Breadcrumbs
        mainTitle={
          currentPathname.includes("/edit") ? "Edit CTA" : "Create CTA"
        }
        parent="CTAs"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <CreateCTAForm />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateCTAContainer;
